<template>
    <section class="bg-white mb-8 shadow rounded-lg col-span-12 md:col-span-6">
        <div class="relative isolate p-6 pb-0">
            <div class="mx-auto max-w-7xl lg:flex lg:items-center lg:gap-x-10">
                <div class="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
                    <img
                        src="../../../images/southwest-logo.svg"
                        alt="Southwest Companion Pass"
                        width="136"
                        height="24"
                    />
                    <div class="mb-5">
                        <h1
                            class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-4xl"
                        >
                            <span class="text-orange">Companion Pass</span>
                            — fly together, save
                            <span class="text-orange">more</span>
                            !
                        </h1>
                        <p class="mt-2 text-sm text-slate-500 font-normal">
                            With the Companion Pass, your next adventure just
                            got twice as
                            <br />
                            exciting — for half the cost! Don’t wait, start
                            earning your pass today.
                        </p>
                        <div class="mt-8">
                            <div
                                class="inline-flex items-center mr-5"
                                v-if="
                                    canShow &&
                                    (settingsPage ||
                                        !fiveTwentyFour ||
                                        canDismiss524Alert)
                                "
                            >
                                <button
                                    type="button"
                                    class="flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-orange shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 text-white"
                                    @click="toggle"
                                    :class="{
                                        'bg-gray-200': !passEnabled,
                                        'bg-orange-500': passEnabled,
                                    }"
                                    role="switch"
                                    aria-checked="true"
                                    :disabled="fiveTwentyFour"
                                >
                                    <span class="text-sm font medium">
                                        Enable Companion Pass Mode
                                    </span>
                                    <input
                                        type="text"
                                        class="hidden"
                                        v-model="passEnabled"
                                        name="card_status"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lg:mt-0 lg:flex-shrink-0 lg:flex-grow">
                    <img src="/images/companionpass/illustration.png" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppStore } from '@/store/app';
import { useCompanionPassStore } from '@/store/companionpass';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    name: 'CompanionPassSection',
    components: { Icon },
    props: {
        settingsPage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    watch: {
        passEnabled() {
            this.userSettings.companion_pass = this.passEnabled;
        },
    },
    computed: {
        ...mapState(useAppStore, ['userSettings']),
        ...mapState(useCompanionPassStore, [
            'passEnabled',
            'fiveTwentyFour',
            'fiveTwentyFourModal',
        ]),
        canShow() {
            if (this.settingsPage) {
                return true;
            }
            return !this.fiveTwentyFour || this.canDismiss524Alert;
        },
    },
    methods: {
        ...mapActions(useAppStore, ['setShowAffiliateModal']),
        ...mapActions(useCompanionPassStore, [
            'getPassData',
            'togglePass',
            'setPassEnabled',
        ]),
        toggle() {
            this.setPassEnabled(!this.passEnabled);
            this.togglePass();
        },
    },
};
</script>
